export default function getResource(label) {
    const resources = {
        oosMessagePrefix: 'Certains articles sont en rupture de stock. ',
        oosMessageLink: 'Choisissez un autre magasin',
        oosMessageSuffix: ' pour passer votre commande, ou changez le mode de livraison pour chaque article concerné.'
    };

    return resources[label];
}
